import { render, staticRenderFns } from "./PrintTextiles.vue?vue&type=template&id=40b363b3&scoped=true"
import script from "./PrintTextiles.vue?vue&type=script&lang=js"
export * from "./PrintTextiles.vue?vue&type=script&lang=js"
import style0 from "./PrintTextiles.vue?vue&type=style&index=0&id=40b363b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b363b3",
  null
  
)

export default component.exports